<div id="wellMaintenance">
    <div class="row justify-between px-6 py-3 card-header">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            Preventive Maintenance Plan Vs Actual
        </div>
        <button (click)="
                openDialog('Well Maintenance', 'wellMaintenance', 'updateData')
            ">
            <ng-container [ngTemplateOutlet]="expandIcon"></ng-container>
        </button>
    </div>

    <div class="p-6">
        <table class="table text-center" style="width: 100%; font-size: 13px">
            <thead>
                <tr class="tableHeader-bg-color">
                    <th scope="col">Well Type</th>
                    <th scope="col">MTD Plan (%)</th>
                    <th scope="col">YTD Actual (%)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data?.data?.items" class="greyBgColor">
                    <td class="greyBgColor">{{ item.wellType }}</td>
                    <td class="greyBgColor">{{ item.mtdPlanPercentage }}%</td>
                    <td class="greyBgColor">{{ item.ytdActualPercentage }}%</td>
                </tr>
            </tbody>
        </table>

        <br />

        <div class="row progress-bar">
            <div *ngFor="let item of data?.data?.summary" [class]="
                    item.status === 'Idle String'
                        ? 'idle-progress-bar'
                        : 'active-progress-bar'
                " class="text-center" [style.width.%]="item.status === 'Idle String' ? 60 : 40">
                {{ item.status }}, {{ item.count }}
            </div>
        </div>
    </div>
</div>